import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'has-background-black': _ctx.isDark })
    }, [
      _createElementVNode("p", {
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, "The home Page", 2)
    ], 2),
    _hoisted_1
  ], 64))
}